import React, { useState } from "react";
import PageLayout from "../components/PageLayout";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Checkbox } from "../components/ui/checkbox";

export default function Profile() {
  const { user, refresh } = useAuth();
  const [paypalEmail, setPaypalEmail] = useState(user?.paypal_email || "");
  const [license, setLicense] = useState(user?.license_number || "");
  const [licenseState, setLicenseState] = useState(user?.license_state || "");
  const [isReviewer, setIsReviewer] = useState(!!user?.is_reviewer);
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await api.post("/onboarding", {
        roles: user.roles.filter(r => ["client", "appraiser"].includes(r)),
        is_reviewer: isReviewer,
        paypal_email: paypalEmail || null,
        license_number: license || null,
        license_state: licenseState || null,
        license_doc_path: user.license_doc_path,
      });
      await refresh();
      toast.success("Saved");
    } catch (e) { toast.error("Save failed"); }
    finally { setSaving(false); }
  };

  return (
    <PageLayout>
      <div className="max-w-2xl">
        <div className="kicker">Profile</div>
        <h1 className="display-serif text-4xl sm:text-5xl mt-2">{user?.name}</h1>
        <p className="text-zinc-600 mt-1">{user?.email}</p>

        <div className="mt-8 flex flex-wrap gap-2">
          {user?.roles?.map(r => <span key={r} className="chip bg-[#CCFBF1] text-[#115E59]">{r}</span>)}
        </div>

        <div className="mt-10 surface-card p-6 lg:p-8 space-y-5">
          <div>
            <Label>PayPal email (for payouts)</Label>
            <Input value={paypalEmail} onChange={e => setPaypalEmail(e.target.value)} data-testid="profile-paypal" />
          </div>
          <div className="grid sm:grid-cols-2 gap-4">
            <div>
              <Label>License number</Label>
              <Input value={license} onChange={e => setLicense(e.target.value)} data-testid="profile-license" />
            </div>
            <div>
              <Label>License state</Label>
              <Input value={licenseState} onChange={e => setLicenseState(e.target.value)} data-testid="profile-license-state" />
            </div>
          </div>
          {user?.roles?.includes("appraiser") && (
            <label className="flex items-start gap-3 cursor-pointer">
              <Checkbox checked={isReviewer} onCheckedChange={setIsReviewer} className="mt-1" />
              <span>
                <span className="font-medium">Reviewer pool</span>
                <span className="block text-sm text-zinc-600">Opt in to review other appraisers&apos; work for a fee.</span>
              </span>
            </label>
          )}
          <button className="btn-ink" onClick={save} disabled={saving} data-testid="profile-save-btn">
            {saving ? "Saving…" : "Save"}
          </button>
        </div>
      </div>
    </PageLayout>
  );
}
